import React from 'react';
import { QUICK_PROMPTS } from '../constants';
import { IconArrowRight } from './ChatIcons';

export default function ChatQuickPrompts({ onSelect }) {
  return (
    <div className="chatbox-quick-section" aria-label="Sugjerime pyetjesh">
      <p className="chatbox-quick-heading">Pyetje të shpeshta</p>
      <div className="chatbox-quick-prompts">
        {QUICK_PROMPTS.map((prompt) => (
          <button
            key={prompt.text}
            type="button"
            className={`chatbox-quick-prompt chatbox-quick-prompt--${prompt.tone}`}
            onClick={() => onSelect(prompt.text)}
          >
            <span className="chatbox-quick-prompt-icon" aria-hidden="true">
              {prompt.icon}
            </span>
            <span className="chatbox-quick-prompt-text">{prompt.text}</span>
            <IconArrowRight className="chatbox-quick-prompt-arrow" />
          </button>
        ))}
      </div>
    </div>
  );
}
